import { render, staticRenderFns } from "./StorageRecords.vue?vue&type=template&id=0f8e095d&scoped=true"
import script from "./StorageRecords.vue?vue&type=script&lang=js"
export * from "./StorageRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8e095d",
  null
  
)

export default component.exports